import { render, staticRenderFns } from "./UsuariosForm.vue?vue&type=template&id=6bd0c104&scoped=true&"
import script from "./UsuariosForm.vue?vue&type=script&lang=js&"
export * from "./UsuariosForm.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosForm.vue?vue&type=style&index=0&id=6bd0c104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0c104",
  null
  
)

export default component.exports